import { useMemo } from 'react';
import { useGetPurchaseOrderDocuments } from '@/services/apis/queries/purchase-order/use-get-purchase-order-documents';

export function usePurchaseOrderActivityTimelineDocument({
  purchaseOrderId,
}: {
  purchaseOrderId: string;
}) {
  const { data: documents } = useGetPurchaseOrderDocuments({
    id: purchaseOrderId,
    page: 1,
    perPage: 1000,
  });

  const documentUrlByName = useMemo(
    () =>
      (documents?.data ?? []).reduce<Record<string, string>>(
        (acc, document) => {
          if (!document.clientUrl || acc[document.name]) {
            return acc;
          }

          acc[document.name] = document.clientUrl;
          return acc;
        },
        {},
      ),
    [documents?.data],
  );

  return {
    documentUrlByName,
  };
}
